/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { SubscriptionHeader } from "../models/subscription-header";
import { SubHeaders } from "../models/sub-headers";
@Injectable({
  providedIn: "root",
})
class SubHeadersService extends __BaseService {
  static readonly subHeadersGetSubHeadersAllPath = "/api/SubHeaders";
  static readonly subHeadersPostSubHeadersPath = "/api/SubHeaders";
  static readonly subHeadersGetSubHeadersPath = "/api/SubHeaders/{id}";
  static readonly subHeadersPutSubHeadersPath = "/api/SubHeaders/{id}";
  static readonly subHeadersDeleteSubHeadersPath = "/api/SubHeaders/{id}";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  subHeadersGetSubHeadersAllResponse(): __Observable<
    __StrictHttpResponse<Array<SubscriptionHeader>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/SubHeaders`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SubscriptionHeader>>;
      })
    );
  }
  subHeadersGetSubHeadersAll(): __Observable<Array<SubscriptionHeader>> {
    return this.subHeadersGetSubHeadersAllResponse().pipe(
      __map((_r) => _r.body as Array<SubscriptionHeader>)
    );
  }

  /**
   * @param subHeaders undefined
   */
  subHeadersPostSubHeadersResponse(
    subHeaders: SubHeaders
  ): __Observable<__StrictHttpResponse<SubHeaders>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = subHeaders;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/SubHeaders`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubHeaders>;
      })
    );
  }
  /**
   * @param subHeaders undefined
   */
  subHeadersPostSubHeaders(subHeaders: SubHeaders): __Observable<SubHeaders> {
    return this.subHeadersPostSubHeadersResponse(subHeaders).pipe(
      __map((_r) => _r.body as SubHeaders)
    );
  }

  /**
   * @param id undefined
   */
  subHeadersGetSubHeadersResponse(
    id: number
  ): __Observable<__StrictHttpResponse<SubHeaders>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/SubHeaders/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubHeaders>;
      })
    );
  }
  /**
   * @param id undefined
   */
  subHeadersGetSubHeaders(id: number): __Observable<SubHeaders> {
    return this.subHeadersGetSubHeadersResponse(id).pipe(
      __map((_r) => _r.body as SubHeaders)
    );
  }

  /**
   * @param params The `SubHeadersService.SubHeadersPutSubHeadersParams` containing the following parameters:
   *
   * - `subHeaders`:
   *
   * - `id`:
   */
  subHeadersPutSubHeadersResponse(
    params: SubHeadersService.SubHeadersPutSubHeadersParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.subHeaders;

    let req = new HttpRequest<any>(
      "PUT",
      this.rootUrl + `/api/SubHeaders/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SubHeadersService.SubHeadersPutSubHeadersParams` containing the following parameters:
   *
   * - `subHeaders`:
   *
   * - `id`:
   */
  subHeadersPutSubHeaders(
    params: SubHeadersService.SubHeadersPutSubHeadersParams
  ): __Observable<Blob> {
    return this.subHeadersPutSubHeadersResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  subHeadersDeleteSubHeadersResponse(
    id: number
  ): __Observable<__StrictHttpResponse<SubHeaders>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "DELETE",
      this.rootUrl + `/api/SubHeaders/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubHeaders>;
      })
    );
  }
  /**
   * @param id undefined
   */
  subHeadersDeleteSubHeaders(id: number): __Observable<SubHeaders> {
    return this.subHeadersDeleteSubHeadersResponse(id).pipe(
      __map((_r) => _r.body as SubHeaders)
    );
  }
}

module SubHeadersService {
  /**
   * Parameters for SubHeadersPutSubHeaders
   */
  export interface SubHeadersPutSubHeadersParams {
    subHeaders: SubHeaders;
    id: number;
  }
}

export { SubHeadersService };
